import { ExpertBio } from "components/read/shared/ExpertBioMapper"
import { findModeratorBySlug } from "components/read/shared/Finder"
import { FullScreenLoading } from "components/read/shared/FullScreenLoading"
import { useContentfulConditionalGate } from "lib/contentful/components/ContentfulConditionGate"
import React from "react"
import { useHistory, useParams } from "react-router"
import useGetExpertBios from "./hooks/useGetExpertBios"
import { ErrorPage } from "pages/provider-finder/ErrorPage"
import { createErrorBoundary } from "utils/createErrorBoundary"
import { useSelector } from "react-redux"
import { getPreferredLocale } from "../../reducers/userInfo"

export type ExpertBioProps = {
  expertBio: ExpertBio
}

const ExperBioElement = ({
  ExpertBioComponent
}: {
  ExpertBioComponent: React.ComponentType<ExpertBioProps>
}): JSX.Element => {
  const history = useHistory()
  const params = useParams<{ expertBio: string }>()
  const preferredLocale = useSelector(getPreferredLocale)

  const { data, isLoading, isError } = useGetExpertBios(preferredLocale)

  const expertBioContent = !isLoading ? (findModeratorBySlug(data, params.expertBio) as ExpertBio[]) : null

  const expertBioConditions = expertBioContent?.map((expertBio) => {
    return {
      element: <ExpertBioComponent expertBio={expertBio} />,
      conditions: expertBio.conditions
    }
  })
  const [expertBio] = useContentfulConditionalGate(expertBioConditions ? expertBioConditions : [])
  if (isLoading) {
    return <FullScreenLoading />
  }

  if ((!isLoading && !expertBio) || isError) {
    history.push("/404")
    return null
  }

  return <>{expertBio}</>
}

export const ExpertBioParser = ({
  ExpertBioComponent
}: {
  ExpertBioComponent: React.ComponentType<ExpertBioProps>
}): JSX.Element => {
  const ExpertBioErrorBoundary = createErrorBoundary(ErrorPage)
  return (
    <ExpertBioErrorBoundary>
      <ExperBioElement ExpertBioComponent={ExpertBioComponent} />
    </ExpertBioErrorBoundary>
  )
}
